import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CircleCheckmarkFillIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm5.23-13.32a1 1 0 0 0-1.46-1.36l-5.3 5.74-2.26-2.27a1 1 0 0 0-1.42 1.42l3 3a1 1 0 0 0 1.44-.03l6-6.5Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default CircleCheckmarkFillIcon;
